import { render } from "./ContentBuilderDataObject.vue?vue&type=template&id=bb527a26"
import script from "./ContentBuilderDataObject.vue?vue&type=script&lang=js"
export * from "./ContentBuilderDataObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__